import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { FileUploadState } from "./types";
import { RootState } from "@/store/types";

const FileUpload: Module<FileUploadState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default FileUpload;
